import React from "react"

import { WithClassName } from "shared/types/WithClassName"

import { ProjectTeamInvitationListModel } from "features/project-team/ui/project-team-invitation-list/types/ProjectTeamInvitationListModel"

import { ProjectTeamInvitationListOverlayView } from "./ui/ProjectTeamInvitationListOverlayView"

export interface ProjectTeamInvitationListOverlayModel {
  projectTeamInvitationListModel: ProjectTeamInvitationListModel
  onClose: () => void
}

export interface ProjectTeamInvitationListOverlayProps
  extends ProjectTeamInvitationListOverlayModel,
    WithClassName {}

export const ProjectTeamInvitationListOverlay = React.memo(
  (props: ProjectTeamInvitationListOverlayProps) => {
    return <ProjectTeamInvitationListOverlayView {...props} />
  }
)
